module.exports = __webpack_public_path__ + "static/esco-9-cda4522693c3a1e302d87832cca2fbcc.png";